<template>
  <div class="modal" v-bind:class="{ 'is-active': is_shown }">
    <div class="modal-background" @click="close_modal"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t("role") }}</p>
        <button class="delete" aria-label="close" @click="close_modal"></button>
      </header>
      <section class="modal-card-body">
        <div class="tabs is-toggle is-fullwidth" ref="tabs">
          <ul>
            <li class="is-active" data-tab="general" @click="change_active_tab">
              <a>
                <i class="info icon" aria-hidden="true"></i>
                <span>{{ $t("general") }}</span>
              </a>
            </li>
            <li
              data-tab="permissions"
              @click="change_active_tab"
              v-bind:class="{ 'is-hidden': !uuid }"
            >
              <a>
                <i class="key icon" aria-hidden="true"></i>
                <span>{{ $t("permissions") }}</span>
              </a>
            </li>
            <li data-tab="settings" @click="change_active_tab">
              <a>
                <i class="settings icon" aria-hidden="true"></i>
                <span>{{ $t("settings") }}</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="container is-fluid" ref="contents">
          <div class="" data-tab="general">
            <form>
              <div class="field">
                <label class="label">{{ $t("name") }}</label>
                <div class="control">
                  <input class="input" type="text" v-model="meta.name" />
                </div>
              </div>
              <div class="field">
                <label class="label">{{ $t("description") }}</label>
                <div class="control">
                  <textarea
                    class="textarea"
                    v-model="meta.description"
                  ></textarea>
                </div>
              </div>
            </form>
          </div>
          <div class="is-hidden" data-tab="permissions">
            <permissions ref="permissions" />
          </div>
          <div class="is-hidden" data-tab="settings">
            <form>
              <div class="field">
                <label class="label">{{ $t("default path") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.settings.default_path"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="notification is-danger mt-5" v-if="error">
          <p v-html="error"></p>
        </div>
      </section>
      <footer class="modal-card-foot">
        <p class="buttons">
          <button
            class="button is-primary is-rounded"
            :disabled="is_form_valid"
            @click="save"
          >
            <span class="icon">
              <i class="fa fa-save"></i>
            </span>
            <span>{{ $t("save") }}</span>
          </button>
          <button class="button is-rounded" @click="close_modal">
            {{ $t("cancel") }}
          </button>
        </p>
      </footer>
    </div>
  </div>
</template>
<script>
import { put, get, post, generate_error_message_text } from "@/utils";
import Permissions from "./Permissions";

export default {
  name: "RoleModal",
  components: { Permissions },
  data() {
    return {
      is_shown: false,
      meta: { settings: {} },
      uuid: "",
      error: "",
    };
  },
  computed: {
    is_form_valid() {
      let v = this;
      return !v.meta.name;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.is_shown = false;
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.is_shown = true;
      v.set_initial_state();
    },
    edit_mode(uuid) {
      let v = this;
      v.set_initial_state();
      v.$refs.permissions.set_role_uuid(uuid);
      get("/access/role", { uuid: uuid })
        .then((rle) => {
          if (rle && rle.name) v.meta.name = rle.name;
          if (rle && rle.description) v.meta.description = rle.description;
          if (rle && rle.settings) v.meta.settings = rle.settings;

          v.uuid = uuid;
          v.is_shown = true;

          v.$refs.permissions.init();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      if (!v.uuid) {
        let obj = { ...v.meta };
        put("/access/role", obj)
          .then(() => {
            v.$emit("success");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        let obj = { ...v.meta };
        obj.uuid = v.uuid;
        post("/access/role", obj)
          .then(() => {
            v.$emit("success");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    set_initial_state() {
      this.meta = {
        name: "",
        description: "",
        settings: {},
      };
      this.$refs.permissions.clear_role_uuid();
      this.error = "";
      this.uuid = "";
    },
    change_active_tab($event) {
      let v = this;
      let target = $event.target;
      let active_tab = "";
      if (target) active_tab = window.jQuery(target).closest("li").data("tab");
      if (active_tab) {
        /** Headers */
        window.jQuery(v.$refs.tabs).find("li").removeClass("is-active");
        window
          .jQuery(v.$refs.tabs)
          .find(`li[data-tab=${active_tab}]`)
          .addClass("is-active");

        /** Content */
        window.jQuery(v.$refs.contents).find(">div").addClass("is-hidden");
        // .attr("display", "none");
        window
          .jQuery(v.$refs.contents)
          .find(`div[data-tab=${active_tab}]`)
          .removeClass("is-hidden");

        // if (active_tab == "permissions") {
        //   v.$refs.permissions.init();
        // }
      }
    },
  },
  mounted() {},
};
</script>
<style></style>
